import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Link } from 'react-router-dom';
import OutsideClickHandler from 'react-outside-click-handler';
import Button from '@material-ui/core/Button';
import '../scss/style.scss';
import threeDotsIcon from '../img/three-dots.svg';

const useStyles = makeStyles((theme) => ({
    root: {
        position: 'relative',
        maxWidth: 200,
    },
    dropdown: {
        position: 'absolute',
        top: 28,
        // padding: 10,
        zIndex: 1,
    },
}));

export default function ClickAway(props) {
    const classes = useStyles();
    const [open, setOpen] = React.useState(false);

    const handleClick = () => {
        setOpen((prev) => !prev);
    };
    const handleClickAway = () => {
        setOpen(false);
    };
    const dropdownItemHandler = (indexDropdownItem, dropdownItem) => {
        handleClickAway();
        props.dropdownItemHandler(indexDropdownItem, dropdownItem);
    }
    return (
        <OutsideClickHandler onOutsideClick={handleClickAway}>
            <div className={classes.root + " " + props.className}>
                <Button aria-controls="simple-menu" aria-haspopup="true" onClick={handleClick}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="3" viewBox="0 0 15 3" fill="none">
                        <path id="ellipsis-h" d="M8.625 1.5C8.625 0.703125 7.92188 0 7.125 0C6.28125 0 5.625 0.703125 5.625 1.5C5.625 2.34375 6.28125 3 7.125 3C7.92188 3 8.625 2.34375 8.625 1.5ZM12.75 0C11.9062 0 11.25 0.703125 11.25 1.5C11.25 2.34375 11.9062 3 12.75 3C13.5469 3 14.25 2.34375 14.25 1.5C14.25 0.703125 13.5469 0 12.75 0ZM1.5 0C0.65625 0 0 0.703125 0 1.5C0 2.34375 0.65625 3 1.5 3C2.29688 3 3 2.34375 3 1.5C3 0.703125 2.29688 0 1.5 0Z" fill="#586268" />
                    </svg>
                </Button>
                {open ?
                    <div className={classes.dropdown + " dropdown-button-operation-list"}>{
                        props.dropdownItems.map((dropdownItem, index) => (
                            (dropdownItem.url === undefined) ?
                                <button className={Boolean(dropdownItem.disable) ? "dropdown-button-operation-link dropdown-button-operation-link__disable" : "dropdown-button-operation-link"} disabled={Boolean(dropdownItem.disable)} onClick={() => dropdownItemHandler(index, dropdownItem)} key={index} >
                                    {dropdownItem.title}
                                </button>
                                :
                                <Link to={dropdownItem.url} className={`dropdown-button-operation-link ${dropdownItem.textDanger ? "text-danger" : ""}`} key={index}>
                                    {dropdownItem.title}
                                </Link>
                        ))
                    }
                    </div>
                    : null}
            </div>
        </OutsideClickHandler>
    );
}